/** Bootstrap placeholder skeletons for account inline views (no spinners on initial load). */

function Skel({ col, h = '1rem', className = '', style }: { col: string; h?: string; className?: string; style?: Record<string, string> }) {
  return <span class={`placeholder ${col} d-block ${className}`.trim()} style={{ height: h, ...style }} />;
}

function SkelField({ labelCol = 'col-4' }: { labelCol?: string }) {
  return (
    <div class="mb-3">
      <Skel col={labelCol} h="0.875rem" className="mb-2" />
      <Skel col="col-12" h="2.375rem" />
    </div>
  );
}

export function ProfileFormSkeleton() {
  return (
    <div class="sw-tickets-shell" aria-busy="true" aria-hidden="true">
      <div class="sw-surface-card sw-profile-card placeholder-glow">
        <div class="row sw-profile-card__grid">
          <div class="col-md-6 border-end-md">
            <Skel col="col-5" h="1.25rem" className="mb-3" />
            <SkelField labelCol="col-3" />
            <SkelField />
            <SkelField />
            <SkelField />
            <SkelField />
            <Skel col="col-6" h="1.25rem" className="mb-3 mt-2" />
            <SkelField />
            <div class="row">
              <div class="col-6"><SkelField /></div>
              <div class="col-6"><SkelField /></div>
            </div>
            <div class="row">
              <div class="col-6"><SkelField /></div>
              <div class="col-6"><SkelField /></div>
            </div>
          </div>
          <div class="col-md-6 ps-md-4">
            <Skel col="col-6" h="1.25rem" className="mb-3" />
            <Skel col="col-8" h="1.25rem" className="mb-3" />
            <Skel col="col-5" h="1.25rem" className="mb-3 mt-2" />
            <SkelField />
            <SkelField />
            <div class="row">
              <div class="col-6"><Skel col="col-12" h="2.375rem" /></div>
              <div class="col-6"><Skel col="col-12" h="2.375rem" /></div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <Skel col="col-3" h="2.5rem" />
        </div>
      </div>
    </div>
  );
}

export function OrderDetailsSkeleton() {
  return (
    <div class="pb-4 placeholder-glow" aria-busy="true" aria-hidden="true">
      <Skel col="col-3" h="2rem" className="mb-3" />
      <Skel col="col-4" h="1.75rem" className="mb-3" />
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <tbody>
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <tr key={i}>
                <td style={{ width: '30%' }}><Skel col="col-10" h="1rem" /></td>
                <td><Skel col="col-8" h="1rem" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function TicketDetailSkeleton() {
  return (
    <div class="sw-tickets-shell placeholder-glow" aria-busy="true" aria-hidden="true">
      <div class="sw-ticket-form-card">
        <div class="d-flex flex-wrap gap-2 mb-3">
          <Skel col="col-3" h="2rem" />
          <Skel col="col-3" h="2rem" />
        </div>
        <Skel col="col-8" h="1.5rem" className="mb-4" />
        <div class="row mb-4">
          <div class="col-sm-6">
            <Skel col="col-10" h="1rem" className="mb-2" />
            <Skel col="col-6" h="1rem" />
          </div>
        </div>
        <hr />
        {[1, 2].map((i) => (
          <div key={i} class="mb-4 p-3 border rounded">
            <Skel col="col-11" h="0.875rem" className="mb-2" />
            <Skel col="col-12" h="4rem" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function ReferralTableSkeleton() {
  return (
    <div class="sw-tickets-shell referral-shell" aria-busy="true" aria-hidden="true">
      <div class="shop-widget-referral-page sw-surface-card referral-card placeholder-glow">
        <Skel col="col-3" h="2rem" className="mb-3" />
        <Skel col="col-12" h="0.875rem" className="mb-3" />
        <div class="table-responsive referral-table-wrap">
          <table class="table referral-table">
            <thead>
              <tr>
                <th><Skel col="col-8" h="0.875rem" /></th>
                <th><Skel col="col-6" h="0.875rem" /></th>
                <th><Skel col="col-6" h="0.875rem" /></th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4].map((i) => (
                <tr key={i}>
                  <td><Skel col="col-10" h="1rem" /></td>
                  <td><Skel col="col-5" h="1rem" /></td>
                  <td><Skel col="col-5" h="1rem" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export function BonusTransactionsSkeleton() {
  return (
    <div class="sw-tickets-shell bonus-transactions-shell" aria-busy="true" aria-hidden="true">
      <div class="shop-widget-bonus-transactions sw-surface-card bonus-transactions-card placeholder-glow">
        <div class="bonus-transactions-card__header mb-3">
          <Skel col="col-3" h="2rem" className="mb-2" />
          <Skel col="col-5" h="1.25rem" />
        </div>
        <div class="table-responsive bonus-transactions-table-wrap">
          <table class="table bonus-transactions-table">
            <thead>
              <tr>
                {[1, 2, 3, 4].map((i) => (
                  <th key={i}><Skel col="col-10" h="0.875rem" /></th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td><Skel col="col-8" h="1rem" /></td>
                  <td><Skel col="col-5" h="1rem" /></td>
                  <td><Skel col="col-5" h="1rem" /></td>
                  <td><Skel col="col-7" h="1rem" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export function SubscriptionsListSkeleton() {
  return (
    <div class="shop-widget-subscriptions placeholder-glow" aria-busy="true" aria-hidden="true">
      <div class="sw-surface-card p-3 p-md-4">
        <div class="d-flex justify-content-end mb-3">
          <Skel col="col-4" h="1.5rem" />
        </div>
        {[1, 2, 3].map((i) => (
          <div key={i} class="d-flex align-items-start gap-3 mb-3 pb-3 border-bottom">
            <Skel col="col-1" h="1.25rem" style={{ minWidth: '1.25rem', maxWidth: '1.25rem' }} />
            <div class="flex-grow-1">
              <Skel col="col-6" h="1rem" className="mb-2" />
              <Skel col="col-11" h="0.875rem" />
            </div>
          </div>
        ))}
        <Skel col="col-3" h="2.5rem" className="mt-2" />
      </div>
    </div>
  );
}
